document.addEventListener('DOMContentLoaded', () => {
    // Mobile menu handling will be added here
    console.log('Theme loaded');
});
